export default {
  getAgent: state => state.agent
};
